import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { ISsoStatus } from "./SsoConfiguration";

export const useStyles = makeStyles<Theme>((theme) => ({
  statusBadge: {
    padding: "3px 10px",
    marginTop: "5px",
    fontWeight: "500",
    borderRadius: "100px",
    display: "inline-flex",
  },
  [ISsoStatus.ACTIVE]: {
    backgroundColor: theme.palette.success.dark,
    color: "white",
  },
  [ISsoStatus.INACTIVE]: {
    backgroundColor: theme.palette.error.dark,
    color: "white",
  },
  [ISsoStatus.PENDING]: {
    backgroundColor: "#e9bf25",
  },
}));
